import { Content, LoadedContent } from "../types/Data/Content";
import { LinkedContent } from "../types/Data/LinkedContent";

export const contentIsLoadedContent = <TLinkedContent extends LinkedContent = LinkedContent>(content: Content): content is LoadedContent<TLinkedContent> => {
    return content.hasOwnProperty("linkedContent");
};
